import { useEffect, useState } from 'react'
import useStoreCategoryData from '../../hooks/useStoreCategoryData'
import Footer from '../../components/Footer/Footer'
import CarouselCupons from './components/CarouselCoupons/CarouselCupons'
import { useLocation, useParams } from 'react-router-dom'
import useUserData from '../../hooks/useUserData'
import useCouponRedirect from '../../hooks/useCouponRedirect'
import useUTMParams from '../../hooks/useUTMParams'
import { useAlert } from '../../context/AlertContext'
import CupomModal from '../../components/Modal/Cupom/Cupom'
import Banner from './components/Banner/Banner'
import { useAuth } from '../../context/AuthContext'
import NavBarEstacio from '../../components/NavBar/NavBarEstacio'
import SliderCategorie from './components/SliderCategorie/SliderCategorie'
import NewCouponsCarousel from './components/NewCouponsCarousel/NewCouponsCarousel'
import AllCoupons from './components/AllCoupons/AllCoupons'
import Filters from '../../components/Filters/Filters'
import { LOGO_HOTAREA } from '../../constants/urls'
import useGetCouponById from '../../hooks/useGetCouponById'
import { Helmet } from 'react-helmet-async'
import { pushData } from '../../utils/dataLayer'
import { categoriasClubeDoAluno } from '../../constants/HomeCupom/categoryIcon'

const ClubeDoAluno = ({slug}) => {


  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get("name");
  const page = queryParams.get("page");
  const category = queryParams.get("category");
  const type = queryParams.get("type");

  const { isAuthenticated } = useAuth();



    
  const { categorie, loadingCategorie, errorCategorie } = useStoreCategoryData({slug})
  // const { coupons, loadingCoupon, errorCoupon, totalPages } = useCouponData({slug})
  // const { coupons, totalPages, totalCoupons, loadingCoupons, errorCoupons } = useTopCoupons({page,limit})
  useEffect(() => {
    if (categorie?.slug) pushData({ category: categorie });
  }, [categorie]);

  const { user, loadingUser, errorUser } = useUserData();
  const { getcouponRedirect } = useCouponRedirect();
  

  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeCoupon = () => {
      setSelectedCoupon(null);
      setIsModalOpen(false);
  };

  const openCoupon = (coupon) => {
      if (!coupon) return;
      setSelectedCoupon(coupon);
      setIsModalOpen(true);
  };

  const { utmSource, utmCampaign } = useUTMParams();

  const { showAlert } = useAlert();

  const logo=`${LOGO_HOTAREA}${categorie.imageName}`

  const { couponId } = useParams();

  const { couponById } = useGetCouponById({ id: couponId });

  useEffect(() => {
  if (!couponId || !couponById) return;

  setSelectedCoupon(couponById);
  setIsModalOpen(true);
  }, [couponId, couponById]);

  

  return (

    <>

      <Helmet>
    
        <title>
          {'Meu Cupom | Clube do Aluno | Descontos e Cashack'}
        </title>
    
      </Helmet>

      <div style={{backgroundColor: "#f1f1f1"}}>
          <NavBarEstacio 
          hotArea={categorie}
          ></NavBarEstacio>
          <Banner
          slug={slug}
          isAuthenticated={isAuthenticated}
          userId={user?.id}
          incentiveId={+categorie?.incentive_id}
          getcouponRedirect={getcouponRedirect}
          utmSource={utmSource}
          utmCampaign={utmCampaign}
          showAlert={showAlert}
          />
          {/* <CarouselCategories/> */}
          <Filters slug={slug} noCount={true}/>
          <CarouselCupons 
          slug={slug}
          name={name}
          page={page} 
          type={type} 
          category={category}
          incentiveId={+categorie?.incentive_id} 
          userId={user?.id}
          getcouponRedirect={getcouponRedirect} 
          utmSource={utmSource} 
          utmCampaign={utmCampaign} 
          showAlert={showAlert} 
          openCoupon={openCoupon} 
          isAuthenticated={isAuthenticated}
          modalTitle={categorie?.name}
          logo={logo}
          />
          <NewCouponsCarousel
              slug={slug}
              name={name}
              page={page} 
              type={type} 
              category={category}
              userId={user.id} 
              incentiveId={+categorie?.incentive_id}
              getcouponRedirect={getcouponRedirect} 
              utmSource={utmSource} 
              utmCampaign={utmCampaign} 
              showAlert={showAlert} 
              openCoupon={openCoupon} 
              isAuthenticated={isAuthenticated}
              order={"RECENT"}
              modalTitle={categorie?.name}
              logo={logo}
          />

          {/* {categoriasClubeDoAluno.map((categoria)=> {

            return(
              <SliderCategorie
              slug={slug}
              name={name}
              page={page} 
              category={categoria.slug} 
              type={type} 
              userId={user.id} 
              incentiveId={categorie?.incentive_id}
              getcouponRedirect={getcouponRedirect} 
              utmSource={utmSource} 
              utmCampaign={utmCampaign} 
              showAlert={showAlert} 
              openCoupon={openCoupon} 
              categoryName={categoria.nome}
              isAuthenticated={isAuthenticated}
              modalTitle={categorie?.name}
              logo={logo}
              
              />
              
            )
          })} */}

          <AllCoupons
          slug={slug} 
          name={name} 
          page={page} 
          type={type}
          category={category}
          isAuthenticated={isAuthenticated} 
          openCoupon={openCoupon}
          getcouponRedirect={getcouponRedirect} 
          utmSource={utmSource} 
          utmCampaign={utmCampaign} 
          userId={user.id} 
          incentiveId={+categorie?.incentive_id}
          showAlert={showAlert} 
          modalTitle={categorie?.name}
          logo={logo}
          />

          

          {isModalOpen && selectedCoupon && (
              <CupomModal
              open={isModalOpen}
              handleClose={closeCoupon}
              couponId={selectedCoupon.id}
              name={selectedCoupon.name}
              slug={selectedCoupon.slug}
              cupomLink={selectedCoupon.linkUrl}
              cupomCode={selectedCoupon.code}
              description={selectedCoupon.description}
              clicks={selectedCoupon.clicks}
              endDate={selectedCoupon.endDate}
              storeName={selectedCoupon.store?.name}
              storeSlug={selectedCoupon.store?.slug}
              cashback={selectedCoupon.store?.cashbackOn ? selectedCoupon.store?.cashbackPercentage * 2 : null}
              incentiveId={+categorie?.incentive_id}
              userId={user.id}
              />
          )}


          <Footer bgColor={'#0095FE'}></Footer>
          
      </div>
    </>
  )
}

export default ClubeDoAluno